import gql from 'graphql-tag';

export default gql(`
	query statistics( $identifier: [String!] ) {
		statistics( identifier: $identifier ) {
			identifier
			name
			data
		}
	}
`);

